module.exports = __webpack_public_path__ + "static/media/aave.851b5115.png";